const messages = {
    accountBox: {
        title: "Koontinäyttö",
        description: "Seuraa kampanjoitasi ja pisteitä nopeasti.",
        button: "AVAA KOONTINÄYTTÖ",
    },
};

export default {
    messages,
};
